<template>
  <q-btn
    class="full-width"
    :class="{ [`bg-${colorName}`]: colorName !== 'custom' }"
    style="min-height: 56px;"
    :style="{ 'background-color': colorName === 'custom' ? `${colorHex} !important` : undefined }"
    :color="isColorPreviewDark() ? 'white' : 'black' "
    :no-caps="noCaps"
    glossy
    unelevated
    outline
    size="lg"
    bottom-slots
    :disable="disable"
  >
    <div class="text-caption text-weight-light">
      <div class="text-capitalize">
        Preview
      </div>
      <div>{{ colorName === 'custom' ? colorHex : colorName }}</div>
    </div>
    <q-menu
      v-if="colorName === 'custom'"
      anchor="top left"
      self="top left"
    >
      <q-color
        :model-value="colorHex"
        :disable="disable"
        @update:model-value="colorHex => $emit('update:model-value', colorHex)"
      />
    </q-menu>
  </q-btn>
</template>

<script>

export default {
  name: 'ColorPicker',
  props: {
    colorName: {
      type: String,
      required: false,
      default: null
    },
    colorHex: {
      type: String,
      required: false,
      default: null
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    noCaps: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  configuration: ['currentSite'],
  emits: ['update:model-value'],
  methods: {
    isColorPreviewDark () {
      let colorHex
      if (this.colorName === 'custom') {
        colorHex = this.colorHex
      } else {
        colorHex = this.$getSiteColorHex(this.currentSite, this.colorName)
      }
      if (!colorHex) return false
      return this.$isColorDark(colorHex)
    }
  }
}
</script>
